<script lang="ts">
    import { appManager } from "../AppManager";

    async function logout() {
        await appManager.logout();

        // redirect to main website to also sign out there.
        // if we are in local development this will redirect to a location signout page.
        window.location.href = `${appManager.RootUrl}signout`;
    }
</script>

{#await logout()}
    <div />
{/await}
